import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28917 29860"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:330.901}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974593129456">
        <path
          d="M19627 4475c0 1643-89 2434-672 3957-314 822-1229 2526-1243 2587-422-35-538-362-1264-651-1129-449-1273-386-2487-386 0-2353-35-3615-890-5895l-1159-2671c-124-250-368-637-425-851 300-7 513-92 737-142 1721-380 4061-335 5765 104 412 106 431 218 599 518 484 866 1039 2097 1039 3430zM9491 14131c0 1196-46 2147 561 3191 117 202 250 307 318 561-1024 541-964 379-2110 1242l-1344 1130c-166 160-278 277-439 439l-1535 1817c-259 360-1266 1741-1356 2076-687-184-2144-2610-2501-3325-357-718-589-1302-866-2094-214-616 241-1164 778-1879 1269-1694 3637-2802 5794-3065l1982-177c392-1 358 76 718 84zM19388 15728c0-1198 61-2143-561-3190-115-193-251-313-317-561 1473-779 2216-1183 3453-2373 533-512 474-535 796-880 981-1055 1855-2167 2535-3451 687 184 2143 2610 2500 3325 358 717 589 1300 866 2094 177 506 84 474-173 966-173 332-372 603-604 913-1269 1693-3637 2802-5795 3064l-1982 178c-392 0-358-77-718-85zM28326 19558c-354 740-233 1317-1421 3288-329 545-605 942-972 1422-1012 1323-993 1197-1837 1197-2678 0-5041-1675-6567-3729-324-436-1220-1690-1334-2178 1234-287 2232-1492 2794-2553l892 544c1780 1080 4914 1820 7008 1930 233 12 487-13 719-1 313 17 384 80 718 80zM12684 10301c-1242 290-2222 1474-2793 2554-261-70-200-105-454-265-1351-847-1994-1079-3626-1561-1707-505-2882-561-4540-648-313-17-383-80-718-80 356-743 230-1312 1422-3287 263-438 1711-2619 2170-2619 2299 0 3333 372 5060 1563 683 471 1644 1491 2145 2165 325 437 1220 1692 1334 2178zM14041 19878h878c0 3247 302 4754 1597 7660 127 286 272 547 424 853 124 248 398 699 453 904-301 7-513 91-738 140-1486 330-3311 334-4826 77-923-156-1179-60-1537-698-1336-2379-1338-4850-368-7387 314-821 1229-2525 1244-2587 464 39 1306 1038 2873 1038z"
          className="fill stroke1"
          style={{
            strokeWidth: 330.901,
          }}
        />
        <path
          d="M16195 15089c0-2745-3511-2268-3511-319 0 2746 3511 2269 3511 319zm2554-239c0 2470-1923 4389-4389 4389-2253 0-4230-1924-4230-4389 0-2251 1918-4229 4389-4229 2239 0 4230 1990 4230 4229z"
          className="fill stroke1"
          style={{
            strokeWidth: 330.901,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
